import { createContext, RefObject } from 'react';

export interface IJoyrideContextProps {
  addNewTaskButtonRef: RefObject<HTMLButtonElement>;
  closeNewTaskDrawerButtonRef: RefObject<HTMLButtonElement>;
}

export const JoyrideContext = createContext<IJoyrideContextProps | null>(null);
